export function processProgramAccreditation(module, mapContainer) {
  let programAccreditationTitle = mapContainer.find('h2:contains("Accreditation")').first();

  if (!programAccreditationTitle.length) {
    return;
  }

  let parentElement = programAccreditationTitle.parent();
  let otherChildren = parentElement.children().not(programAccreditationTitle);

  if (!otherChildren.length) {
    module.hide();
    return;
  }

  let programNoteDataContainer = module.find(".js-programAccreditationData");
  programNoteDataContainer.html(otherChildren.html());
}